import { InvoiceProviderAccountInfo } from '@dreryk/egabinet-invoice-frontend-api';

import { Heading, StyledFlex } from '@dreryk/react-components';

import { invoicePanelTranslationKeys } from '../translations';

import { IntegrationEnabledInfo } from './details/IntegrationEnabledInfo';
import { YourLoginInfo } from './details/YourLoginInfo';
import { YourUrlInfo } from './details/YourUrlInfo';

type InvoiceProviderAccountDetailsProps = {
   readonly invoiceOfferUrl: string;
   readonly currentInvoiceProviderAccountInfo: InvoiceProviderAccountInfo;
};

export const InvoiceProviderAccountDetails = (props: InvoiceProviderAccountDetailsProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'}>
         <Heading content={invoicePanelTranslationKeys.invoiceProviderAccountInfo} testId={'heading'} type={'h2'} />
         <StyledFlex direction={'column'} gap={'12px'}>
            <IntegrationEnabledInfo invoiceOfferUrl={props.invoiceOfferUrl} />
            <YourLoginInfo login={props.currentInvoiceProviderAccountInfo.login} />
            <YourUrlInfo url={props.currentInvoiceProviderAccountInfo.url} />
         </StyledFlex>
      </StyledFlex>
   );
};
